<template>
    <div>
        <div id="header">
            <img class="back" src="../../assets/common_back.png" alt=""
                 @click="back">
            <span class="title">活动报名</span>
            <img
                    class="more"
                    src=""
                    @click="display = true"
                    alt="">
        </div>

        <div id="body-form">
            <div class="info" style="background: #cccccc">
                <input class="input" type="text" name="memberNumber"
                       placeholder="会员名"
                       v-model="username" disabled style="background: #cccccc; color: #000000">
            </div>

            <div class="info">
                <input class="input" type="text" name="memberNumber"
                       placeholder="真实姓名"
                       v-model="realName" maxlength="50">
            </div>

            <div>
                <p style="text-align: left">选择地址：</p>
                <area-components style="margin: 0px" @selectArea="getAreaId" :provinceProps ="province" :cityProps="city" :areaProps="area"/>
            </div>


            <div class="info">
                <input class="input" type="text" name="memberNumber"
                       placeholder="详细地址"
                       v-model="address">
            </div>

            <div class="info">
                <input class="input" type="text" name="memberNumber"
                       placeholder="电话"
                       v-model="mobile" maxlength="11">
            </div>
        </div>


        <button class="report-btn" @click="activityReport" :disabled="btnDisable">
            报名
        </button>

        <div class="toast" v-show="toastShow">
            {{toastText}}
        </div>
    </div>
</template>

<script>
    import {activityReport} from "../../api/Stamp";
    import {memberDetail} from "@/api/Member";
    import AreaComponents from "@/components/AreaComponents";

    export default {
        name: "StampExchangeReport",
        components: {AreaComponents},
        data() {
            return {
                username: '',
                realName: '',
                address: '',
                mobile: '',
                activityId: this.$route.query.activityId,
                province: '',
                city: '',
                area: '',
                stamp: 0,
                stampQuantity: this.$route.query.stampQuantity,

                toastShow: false,
                toastText: '',

                success: false,

                btnDisable: false,
            }
        },

        mounted() {
            this.memberDetail();
        },

        methods: {
            back() {
                this.$router.go(-1);
            },

            toast (e) {
                let _that = this;
                this.toastText = e;
                this.toastShow = true;
                setTimeout(function(){
                    _that.toastShow = false;

                    if (_that.success) {
                        _that.$router.go(-1);
                    }
                }, 1500)
            },


            activityReport() {
                if (this.stampQuantity > this.stamp) {
                    this.toast("印花不足,无法进行兑换");
                    return;
                }

                if (this.realName === '') {
                    this.toast("请输入真实姓名");
                    return;
                }

                if (this.realName.trim().length > 50) {
                    this.toast("真实姓名长度不能超过50个汉字");
                    return;
                }

                if (this.province === '' || this.city === '' || this.area === '' || this.address === '') {
                    this.toast('请选择地址');
                    return;
                }

                let telReg = /^1[3456789]\d{9}$/;
                if (!telReg.test(this.mobile)) {
                    this.toast("请输入正确的电话号码");
                    return;
                }
                this.btnDisable = true;

                activityReport(this.activityId, this.username, this.realName, this.province, this.city , this.area, this.address, this.mobile )
                    .then(response => {
                    if (this.$API_CODE.OK === response.code) {
                        this.toast('报名成功');
                        this.success = true;
                    }
                    this.btnDisable = false;
                });

            },

            getAreaId(selectProvince, selectCity, selectArea) {
                this.province = selectProvince;
                this.city = selectCity;
                this.area = selectArea;
            },

            //获取用户信息
            memberDetail() {
                memberDetail()
                    .then((response) => {
                        if (response.code === this.$API_CODE.OK) {
                            this.username = response.data.username;
                            this.stamp = response.data.stamp;
                        }
                    })
            },


        }
    }
</script>

<style scoped lang="scss">

    #header {
        height: 45px;
        line-height: 45px;
        background-color: #ed3f14;

        .back {
            margin-top: 13px;
            line-height: 35px;
            margin-left: 10px;
            float: left;
        }

        .more {
            width: 16px;
            height: 16px;
            margin-top: 8px;
            line-height: 35px;
            margin-right: 10px;
            float: right;
        }

        .title {
            color: white;
        }
    }

    #body-form {
        clear: both;
        margin-left: 20px;
        margin-right: 20px;
        margin-top: 30px;

        .info {
            width: auto;
            height: 45px;
            border-radius: 5px;
            border: 2px solid #ed3f14;
            display: flex;
            align-items: center;
            margin-top: 20px;
            background: #FFFFFF;
        }

        .icon {
            width: 16px;
            height: 16px;
            float: left;
            margin-left: 20px;
        }

        .input {
            height: 35px;
            border: 0;
            outline: none;
            margin-left: 30px;
            font-size: 1rem;
            width: 100%;
        }
    }


    .report-btn {
        width: 90%;
        /*height: 35px;*/
        margin-left: 20px;
        margin-right: 20px;
        border-radius: 5px;
        background-color: #ed3f14;
        line-height: 35px;
        margin-top: 20px;
        text-align: center;
        color: white;
        font-size: 1rem;
        border: none;
    }
</style>